if (!customElements.get('cart-bought-sync')) {
  class CartBoughtSync extends HTMLElement {
    connectedCallback() {
      const target = document.querySelector('[data-cart-bought-desktop]');
      const template = this.querySelector('template');
      if (!target || !template) return;

      if (template.content.childElementCount > 0) {
        target.replaceChildren(template.content.cloneNode(true));
      } else {
        target.replaceChildren();
      }

      [this.closest('.cart-drawer__inner'), this.closest('.cart-drawer__body')?.querySelector('.cart-drawer__main')]
        .filter(Boolean)
        .forEach(el => {
          el.scrollLeft = 0;
          if (el._cartBoughtScrollGuard) return;
          el._cartBoughtScrollGuard = true;
          el.addEventListener('scroll', () => {
            if (el.scrollLeft !== 0) el.scrollLeft = 0;
          }, { passive: true });
        });
    }
  }

  customElements.define('cart-bought-sync', CartBoughtSync);

  document.addEventListener('mousedown', event => {
    if (event.target.closest('.cart-bought__add')) event.preventDefault();
  });

  document.addEventListener('click', event => {
    const button = event.target.closest('.cart-bought__add');
    if (!button || document.querySelector('quick-cart-drawer')) return;
    event.preventDefault();

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer ? cartDrawer.getSectionsToRender().map(section => section.section) : [];
    button.classList.add('is--loading');

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections,
        sections_url: window.location.pathname
      })
    })
      .then(response => response.json())
      .then(response => {
        if (response.status) throw new Error(response.description || response.message);
        if (cartDrawer) {
          cartDrawer.renderContents(response);
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(error => {
        console.error(error);
        button.classList.remove('is--loading');
      });
  });
}
